export const LOCALE_PREFIX = 'scenes.Error'
